module.exports = __webpack_public_path__ + "img/ai3.33faba31.png";